module.exports = __webpack_public_path__ + "static/media/pooltogether.b157ca3d.svg";